// src/app/components/injections.ts
const LayoutMetaSymbol = Symbol("layout-meta");
const LayoutSymbol = Symbol("layout");
const PageRouteSymbol = Symbol("route");
export { LayoutMetaSymbol, LayoutSymbol, PageRouteSymbol };
